<template>
  <div>
    <div class="login-wrp">
      <img class="login-icon c-p" src="../assets/cosmolove-logo-3.png" @click="goHome" />
      <div class="login-content clearfix">
        <img class="login-banner pull-left" src="../assets/login_qrcode.png" />
        <form class="login-form pull-right" @submit.prevent="login()">
          <h4 class="login-form-header">登录</h4>
          <input placeholder="请输入手机号" type="text" class="f-w login-f-control m-b" v-model="username" />
          <input placeholder="请输入密码" type="password" class="f-w login-f-control" v-model="password" />
          <button class="c-b-login c-b-primary f-w m-t-md":disabled="loginDisabled()">登录</button>
          <div class="text-small text-gray" style="margin-top: 20px;">
            登录即表示同意
            <a class="link-text" target="_blank" href="#/user/policy">《时尚新娘用户协议》</a>
            <a class="link-text register" href="#/register">立即注册></a>
          </div>
          <div class="forget-pw">
            <a href="#/forgetpass">忘记密码></a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import toastr from 'mini-toastr';
import md5 from 'blueimp-md5';
import uService from '../service/user';

export default {
  name: 'Login',
  created() {
//    if (uService.hasLogin()) {
//      location.href = '#/';
//    }
  },
  data() {
    return {
      username: undefined,
      password: undefined,
    };
  },
  methods: {
    login() {
      if (!this.username || !this.password) {
        return false;
      }
      uService.login(this.username, md5(this.password))
        .then((resp) => {
          if (resp.status === 0) {
            localStorage.setItem('telephone', resp.data.telephone);
            console.log(localStorage.getItem('telephone'));
            location.href = '#/';
            toastr.success('登录成功');
          }
        });
      return false;
    },
    loginDisabled() {
      return !this.username || !this.password;
    },
    goHome() {
      this.$router.replace({ name: 'Index' });
    },
  },
};
</script>
<style scoped>
.login-wrp {
  width: 1000px;
  margin: 0 auto 71px;
}
.login-icon {
  width: 111px;
  height: 56px;
  margin-top: 24px;
}
.login-content {
  margin-top: 144px;
}
.login-form {
  width: 371px;
	height: 371px;
	border: solid 1px #e1e1e1;
  padding: 30px 35px;
}
.login-form-header {
  font-size: 18px;
  margin-bottom: 45px;
  margin-top: none;
  font-weight: normal;
}
.register {
  float: right;
  font-size: 12px;
}
.forget-pw {
  text-align: right;
  margin-top: 21px;
  font-size: 12px;
}
.forget-pw > a {
  color: #999;
}
.forget-pw > a:hover {
  color: #df3a4e;
  text-decoration: none;
}
.c-b:active,
.c-b:focus,
.c-b-login:active,
.c-b-login:focus,
.f-control:focus {
  outline: 0 none;
}

.login-footer h4 {
  color: #fff;
  margin: 45px 0 44px;
}
.login-footer > div {
  display: inline-block;
  margin-right: 199px;
  text-align: left;
  vertical-align: top;
}
.login-footer > div:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// Login.vue?2abf7c52